import React from 'react';
import PropTypes from 'prop-types';
import Schedules from '../../../../../common/schedulesForm/schedules';
import ScheduleSummary from './ScheduleSummary';

const BrandSchedule = ({
  canModify,
  selectedLocation,
  schedules,
  scheduleSummary,
  minInterval,
  activeTab,
  setTabTo,
}) => (
  <div className="u-mv" data-automation-id="schedule-tab">
    <div className="layout u-position-relative">
      <div className="layout__item u-1/2-large-and-up">
        <fieldset disabled={!canModify}>
          <Schedules
            shopId={selectedLocation}
            schedules={schedules}
            minInterval={minInterval}
            activeTab={activeTab}
            setTabTo={setTabTo}
          />
        </fieldset>
      </div>
      <div className="layout__item u-1/2-large-and-up c-schedule-summary-container">
        <ScheduleSummary scheduleSummary={scheduleSummary[activeTab]} />
      </div>
    </div>
  </div>
);

BrandSchedule.propTypes = {
  canModify: PropTypes.bool,
  minInterval: PropTypes.number,
  selectedLocation: PropTypes.string.isRequired,
  schedules: PropTypes.object.isRequired,
  scheduleSummary: PropTypes.shape({
    current: PropTypes.arrayOf(PropTypes.object),
    future: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  activeTab: PropTypes.oneOf(['current', 'future']).isRequired,
  setTabTo: PropTypes.func.isRequired,
};

BrandSchedule.defaultProps = {
  canModify: true,
  minInterval: 15,
};

export default BrandSchedule;
